import uniqueid from 'lodash.uniqueid';
import {useMemo} from "react";

export function useUniqueId(prefix: string = 'input-') {
  return useMemo(() => uniqueid(prefix), [prefix]);
}